import { apolloClient } from "../ApolloClient"
import { parseDoorhubToken } from "./parse-doorhub-token"
import { BearerAuthentication } from "./authentication-types"
import { gql } from "@apollo/client"
import { useEffect } from "react"

const VIEWER_PORTAL_ADDRESS = gql`
	query ViewerPortalAddress {
		viewer {
			portalAddress
		}
	}
`

const CREATE_TOKEN_FROM_PORTAL_CODE = gql`
  mutation CreateTokenFromPortalOauthCode($input: CreateTokenFromPortalOauthCode!) {
	createTokenFromPortalOauthCode(input: $input) {
	  token
	}
  }
`

export async function fetchPortalAddress(): Promise<string> {
	const { data } = await apolloClient.query({ query: VIEWER_PORTAL_ADDRESS, fetchPolicy: "network-only" })
	const portalAddress = data?.viewer?.portalAddress
	if (!portalAddress) {
		throw new Error("Portal address not available from server")
	}
	return portalAddress
}

export async function gotoPortalAuth() {
	const portalAddress = await fetchPortalAddress()
	const redirectUri = window.location.origin + "/oauth_return"
	const url = new URL(`https://${portalAddress}/login`)
	url.searchParams.set("response_type", "code")
	url.searchParams.set("client_id", "doorhub")
	url.searchParams.set("redirect_uri", redirectUri)
	window.location.href = url.toString()
}

export async function signInToDoorhubWithPortal(code: string): Promise<BearerAuthentication> {
	const { data, errors } = await apolloClient.mutate({
		mutation: CREATE_TOKEN_FROM_PORTAL_CODE,
		variables: { input: { code } },
	})

	if (errors && errors.length) {
		throw errors[0]
	}

	const token: string | undefined = data?.createTokenFromPortalOauthCode?.token
	if (!token) {
		throw new Error("No token returned from portal OAuth exchange")
	}

	return parseDoorhubToken(token)
}

export function usePortalOauthReturnDetector(callback: (code: string) => void, onError?: (message: string) => void) {
	useEffect(() => {
		if (typeof window === "undefined") return

		try {
			const url = new URL(window.location.href)
			if (url.pathname !== "/oauth_return") {
				return
			}

			const error = url.searchParams.get("error")
			const code = url.searchParams.get("code")

			url.searchParams.delete("code")
			url.searchParams.delete("error")
			window.history.replaceState({}, document.title, "/")

			if (error) {
				onError?.(error)
				return
			}

			if (code) {
				callback(code)
			}
		} catch (_e) {
			// ignore
		}
	}, [callback, onError])
}
